import { useQuery } from '@tanstack/react-query'

import MedicalRecordsService from 'services/medicalRecords'
import { MedicalRecordForm } from 'models/MedicalRecord/MedicalRecordForm.type'

const MEDICAL_RECORD_FORM_QUERY_KEY = 'MEDICAL_RECORD_FORM'

interface UseMedicalRecordFormResult {
  form: MedicalRecordForm | undefined
  isLoading: boolean
  isError: boolean
}

export function useMedicalRecordForm(formUuid: string | null): UseMedicalRecordFormResult {
  const { data, isLoading, isError } = useQuery<MedicalRecordForm>(
    [MEDICAL_RECORD_FORM_QUERY_KEY, formUuid],
    () => MedicalRecordsService.getForm(formUuid as string),
    {
      enabled: Boolean(formUuid),
      retry: 1,
      refetchOnWindowFocus: false,
    },
  )

  return {
    form: data,
    isLoading,
    isError,
  }
}
